import React from "react"
import WingsCardContainer from "./WingsCardContainer"
import { WingsBadge } from "../badges"
import { FormattedMessage } from "react-intl"

const WingsMajorCard = ({
  img,
  title = "",
  slug,
  category,
  bachelor,
  associate,
  graduate,
  master,
  doctorate,
  objectID,
  contentType = "majors",
}) => {
  // insert 0-width white space characters after / characters to allow major
  // names with long sections of / separated text to wrap
  const wrappableTitle = title.replaceAll('/', '/\u200B')
  const degreeLevels = []
  if (associate) {
    degreeLevels.push(<FormattedMessage id="cards-major-associates" defaultMessage="Associate's" />)
  }
  if (bachelor) {
    degreeLevels.push(<FormattedMessage id="cards-major-bachelor" defaultMessage="Bachelor's" />)
  }
  if (graduate) {
    degreeLevels.push(<FormattedMessage id="cards-major-graduate" defaultMessage="Graduate" />)
  }
  if (master) {
    degreeLevels.push(<FormattedMessage id="cards-major-masters" defaultMessage="Master's" />)
  }
  if (doctorate) {
    degreeLevels.push(<FormattedMessage id="cards-major-doctorate" defaultMessage="Doctorate" />)
  }
  return (
    <WingsCardContainer
      imageUrl={img || "https://imgix.cosmicjs.com/90920fd0-6000-11eb-ad8f-d1a7eae548e8-major1.jpg"}
      imageAlt={title ? `image of ${title}` : 'Major image'}
      title={wrappableTitle} 
      to={`/major/${slug}`}
      subtitle={category}
      objectID={objectID}
      slug={slug}
      contentType={contentType}
    >
      {degreeLevels.length > 0 && (
        <div className="w-flex w-flex-row w-flex-wrap w-justify-start w-items-center w-gap-xs">
          {degreeLevels.map((degree, idx) => (
            <WingsBadge key={idx} size="narrow">
              {degree}
            </WingsBadge>
          ))}
        </div>
      )}
    </WingsCardContainer>
  )
}

export default WingsMajorCard
